import 'firebase/analytics'
import firebase from 'firebase/app'


export default firebase.initializeApp({
    projectId: 'long-distance-285517',
    apiKey: 'AIzaSyDCMzdrQAXI6kp0BmQWCeinht-SQ3b3cwg',
    authDomain: 'long-distance-285517.firebaseapp.com',
    databaseURL: 'https://long-distance-285517.firebaseio.com',
    storageBucket: 'long-distance-285517.appspot.com',
    messagingSenderId: '63804595787',
    appId: '1:63804595787:web:a69422bcea4585aff5b7ce',
    measurementId: 'G-QYZLQLPLNK'
}) as firebase.app.App

firebase.analytics()

export { firebase }
